import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';

function TicketList({
    tickets,
    showArchived,
    setShowArchived,
    getTicketTypeLabel,
    getTicketStatusLabel,
    handleOpenDetailsModal,
    handleOpenConfirmationModal
}) {

    // 🔹 Filtrage mémorisé
    const filteredTickets = useMemo(() => {
        if (!tickets) return [];
        return tickets.filter(ticket =>
            showArchived || ticket.status !== 'ARCHIVED'
        );
    }, [tickets, showArchived]);

    return (
        <>
            {/* Toggle archived */}
            <div style={{ marginBottom: '15px' }}>
                <input
                    type="checkbox"
                    id="archivedToggle"
                    checked={showArchived}
                    onChange={(e) => setShowArchived(e.target.checked)}
                />
                <label htmlFor="archivedToggle" style={{ marginLeft: '8px' }}>
                    Inclure les demandes archivées ?
                </label>
            </div>

            {/* Loading */}
            {tickets === null && (
                <div className="kubuni-frame" style={{ paddingBottom: '10px' }}>
                    Chargement des demandes en cours...
                </div>
            )}

            {/* Empty */}
            {tickets !== null && filteredTickets.length === 0 && (
                <div className="kubuni-frame" style={{ paddingBottom: '10px' }}>
                    Vous n'avez pas encore créé de demande
                </div>
            )}

            {/* Table */}
            {filteredTickets.length > 0 && (
                <table className="table bordered-table">
                    <thead>
                        <tr>
                            <th className="text-center">N°</th>
                            <th className="text-center">Type</th>
                            <th className="text-center">Statut</th>
                            <th className="text-center">Titre</th>
                            <th />
                        </tr>
                    </thead>

                    <tbody>
                        {filteredTickets.map(ticket => (
                            <tr key={ticket.id}>
                                <td className="text-center">{ticket.id}</td>
                                <td className="text-center">
                                    {getTicketTypeLabel(ticket.ticketType)}
                                </td>
                                <td className="text-center">
                                    {getTicketStatusLabel(ticket.status)}
                                </td>
                                <td className="text-center">
                                    {ticket.subject}
                                </td>
                                <td className="text-center">

                                    <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={() => handleOpenDetailsModal(ticket)}
                                        style={{ margin: '0 5px' }}
                                    >
                                        Voir
                                    </Button>

                                    {ticket.status !== 'CLOSED' &&
                                        ticket.status !== 'ARCHIVED' && (
                                            <Button
                                                variant="warning"
                                                size="sm"
                                                onClick={() =>
                                                    handleOpenConfirmationModal('CLOSED', ticket)
                                                }
                                                style={{ margin: '0 5px' }}
                                            >
                                                Clôturer
                                            </Button>
                                        )}

                                    {ticket.status !== 'ARCHIVED' && (
                                        <Button
                                            variant="secondary"
                                            size="sm"
                                            onClick={() =>
                                                handleOpenConfirmationModal('ARCHIVED', ticket)
                                            }
                                            style={{ margin: '0 5px' }}
                                        >
                                            Archiver
                                        </Button>
                                    )}

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </>
    );
}

export default TicketList;